"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLazyPropType;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

function createLazyPropType(rawPropType) {
  var propTypeWithFuncEval = function propTypeWithFuncEval(props, propName) {
    var value = props[propName];

    if (!value) {
      return null;
    } // If the value is not a function, check that it satisfies rawPropType


    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    if (typeof value !== 'function') {
      return rawPropType.apply(void 0, [props, propName].concat(rest));
    } // Check that the value returned by the function satisfies rawPropType


    var modifiedProps = (0, _extends2.default)({}, props);
    modifiedProps[propName] = value();
    return rawPropType.apply(void 0, [modifiedProps, propName].concat(rest));
  }; // Name this propType "lazyX", where "X" is the name of the raw prop type


  var rawPropTypeName = rawPropType.__INTROSPECTION__ ? rawPropType.__INTROSPECTION__.type : 'value';
  var lazyPropTypeName = "lazy" + (rawPropTypeName.charAt(0).toUpperCase() + rawPropTypeName.slice(1));
  var chainablePropType = (0, _createChainablePropType.default)(propTypeWithFuncEval, lazyPropTypeName);
  return chainablePropType;
}

module.exports = exports.default;